import React from 'react';
import ModalWrapper from '../../helpers/modalWrapper';
import FilePreview from './FilePreview';
import { Button, Loader, Link, Alert } from 'arag-ui-lib';
import { SIZE_LG, DOWNLOAD, DOTS, MEDIUM, TERTIARY, LEFT, ERROR } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const FilePreviewModal = ({
    isOpen,
    file,
    loading,
    error,
    onClose,
    onDownload
}) => {
    const renderContent = () => {
        if (loading) {
            return (
                <div className="file-preview-modal__loading">
                    <Loader variant={DOTS} dotSize={MEDIUM} />
                </div>
            );
        }

        if (error) {
            return (
                <div className='col-sm-12'>
                    <Alert label={error} variant={ERROR} />
                </div>
            );
        }

        if (!file?.encodedFile) {
            return null;
        }

        return (
            <FilePreview
                base64={file.encodedFile}
                fileName={file.name}
            />
        );
    };

    const footer = (
        <div className="file-preview-modal__footer">
            <Link
                label={CONTENT_STRINGS.CLOSE}
                variant={TERTIARY}
                arrowDirection={LEFT}
                onClick={onClose}
                linkTestId="file-preview-close"
            />
        </div>
    );

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            size={SIZE_LG}
            title={file?.name || ''}
            footer={footer}
            modalTestId="file-preview-modal"
        >
            <div className="file-preview-modal__download">
                <Button
                    variant={DOWNLOAD}
                    label={CONTENT_STRINGS.DOWNLOAD}
                    onClick={onDownload}
                    buttonTestId="file-preview-download"
                />
            </div>
            {renderContent()}
        </ModalWrapper>
    );
};

export default FilePreviewModal;
